export default __webpack_public_path__ + "static/media/news-5.bfb6a4a4.jpg";